import { render, staticRenderFns } from "./GewerbeStep5.vue?vue&type=template&id=a739d3d0&"
import script from "./GewerbeStep5.vue?vue&type=script&lang=js&"
export * from "./GewerbeStep5.vue?vue&type=script&lang=js&"
import style0 from "./GewerbeStep5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VRow,VSpacer})
